import {
  SET_USERNAME,
  SET_TYPING_DATA,
  SET_CONVERSATIONS,
  APPEND_CONVERSATIONS,
  SET_CONVERSATION_PAGINATION,
  SET_CURRENT_ROOM,
  SET_CURRENT_ROOM_MESSAGES,
  UPDATE_CURRENT_ROOM_MESSAGES,
  UPDATE_CURRENT_ROOM_HISTORY,
  SET_PARTICIPANTS_DETAILS,
  UPDATE_CONVERSATION,
  SET_SYSTEM_MESSAGE_SEEN_DATA,
  ALL_MESSAGES_ARE_LOADED,
  MESSAGES_LOADING,
  SET_CONVERSATION_TOPICS,
  UPDATE_CONVERSATION_TOPIC,
  UPDATE_CONVERSATION_TOPICS,
  SET_CURRENT_TOPIC,
  CONVERSATION_TOPICS_LOADING,
  UPDATE_CONVERSATION_LAST_ACTIVITY,
  UPDATE_CONVERSATIONS_LIST,
  ADD_TO_SEND_MESSAGE_QUEUE,
  REMOVE_FROM_SEND_MESSAGE_QUEUE,
  UPDATE_USER_PERMISSIONS,
  SET_PARTICIPANTS_COUNT,
  UPDATE_LAST_SEEN,
  TOGGLE_CONVERSATION_INFO_PANEL,
  REMOVE_CONVERSATION_FROM_LIST,
  USER_ONLINE,
  SET_URL_CONVERSATION_LOADING,
  SET_URL_CONVERSATION_ERROR,
  SET_MAIL_MESSAGES,
  UPDATE_MAIL_HISTORY,
  ALL_MAIL_MESSAGES_LOADED,
  SET_AUTOMATION_STATUS,
  SET_CONVERSATION_FILTER,
} from "./types";

function setUserName(userName) {
  return {
    type: SET_USERNAME,
    payload: {
      userName,
    },
  };
}

function setUserOnline(isOnline) {
  return {
    type: USER_ONLINE,
    payload: {
      isOnline,
    },
  };
}

function setConversationId(conversationId) {
  return {
    type: SET_CURRENT_ROOM,
    payload: {
      conversationId,
    },
  };
}

function setRoomMessages(conversationId, messages, topicId = null) {
  return {
    type: SET_CURRENT_ROOM_MESSAGES,
    payload: {
      conversationId,
      messages,
      topicId,
    },
  };
}

function updateRoomHistory(
  conversationId,
  messages,
  topicId = null,
  direction = "lte"
) {
  return {
    type: UPDATE_CURRENT_ROOM_HISTORY,
    payload: {
      conversationId,
      messages,
      topicId,
      direction,
    },
  };
}

function addToSendMessageQueue(conversationId, message) {
  return {
    type: ADD_TO_SEND_MESSAGE_QUEUE,
    payload: {
      conversationId,
      message,
    },
  };
}

function removeFromSendMessageQueue(conversationId, index) {
  return {
    type: REMOVE_FROM_SEND_MESSAGE_QUEUE,
    payload: {
      conversationId,
      index,
    },
  };
}

function updateRoomMessages(conversationId, message) {
  return {
    type: UPDATE_CURRENT_ROOM_MESSAGES,
    payload: {
      conversationId,
      message,
    },
  };
}

function updateConversation(updatedConversation) {
  /**
   * @param updateConversation: {
   *    conversationId: string,
   *    conversation: {
   *        // conversationParticipantModal
   *    }
   * }
   */
  return {
    type: UPDATE_CONVERSATION,
    payload: updatedConversation,
  };
}

function setSystemTypingData(payload) {
  return {
    type: SET_TYPING_DATA,
    payload,
  };
}

function setSystemMessageSeenData(payload) {
  return {
    type: SET_SYSTEM_MESSAGE_SEEN_DATA,
    payload,
  };
}

function setConversations(payload) {
  return {
    type: SET_CONVERSATIONS,
    payload,
  };
}

function appendConversations(payload) {
  return {
    type: APPEND_CONVERSATIONS,
    payload,
  };
}

function setConversationPagination(payload) {
  return {
    type: SET_CONVERSATION_PAGINATION,
    payload,
  };
}

function setConversationTopicList(
  conversationId,
  topics,
  currentCount,
  page,
  totalCount
) {
  return {
    type: SET_CONVERSATION_TOPICS,
    payload: {
      [conversationId]: topics,
      currentCount,
      page,
      totalCount,
    },
  };
}

function updateConversationTopic(conversationId, topic) {
  return {
    type: UPDATE_CONVERSATION_TOPIC,
    payload: {
      conversationId,
      topic,
    },
  };
}

function updateConversationTopics(conversationId, topics, total) {
  return {
    type: UPDATE_CONVERSATION_TOPICS,
    payload: {
      conversationId,
      topics,
      total,
    },
  };
}

function selectConversationTopic(payload) {
  return {
    type: SET_CURRENT_TOPIC,
    payload,
  };
}

function setParticipantsDetails(conversationId, participants) {
  return {
    type: SET_PARTICIPANTS_DETAILS,
    payload: {
      conversationId,
      participants,
    },
  };
}

function setParticipantsCount(conversationId, count) {
  return {
    type: SET_PARTICIPANTS_COUNT,
    payload: {
      conversationId,
      count,
    },
  };
}

function setAllMessagesAreLoaded(conversationId, topicId) {
  return {
    type: ALL_MESSAGES_ARE_LOADED,
    payload: {
      conversationId,
      topicId,
    },
  };
}

function setMessageLoadingState(roomId, state, topicId = null) {
  // Create a composite key when topicId is present to support topic-level loading
  const key = topicId ? `${roomId}_${topicId}` : roomId;
  return {
    type: MESSAGES_LOADING,
    payload: {
      [key]: state,
    },
  };
}

function loadingConversationTopics(conversationId, loading) {
  return {
    type: CONVERSATION_TOPICS_LOADING,
    payload: {
      [conversationId]: loading,
    },
  };
}

function updateConversationLastActivity(conversationId, message) {
  return {
    type: UPDATE_CONVERSATION_LAST_ACTIVITY,
    payload: {
      conversationId,
      message,
      topicId: message.topicId,
    },
  };
}

function updateConversationsList(conversation) {
  return {
    type: UPDATE_CONVERSATIONS_LIST,
    payload: conversation,
  };
}

function removeConversation(conversationId) {
  return {
    type: REMOVE_CONVERSATION_FROM_LIST,
    payload: { conversationId },
  };
}

function updateUserPermissions(eventId, permission, value) {
  return {
    type: UPDATE_USER_PERMISSIONS,
    payload: {
      eventId,
      update: {
        [permission]: value,
      },
    },
  };
}

function updateLastSeen(conversationId, lastSeen) {
  return {
    type: UPDATE_LAST_SEEN,
    payload: {
      conversationId,
      lastSeen,
    },
  };
}

function toggleConversationInfoPanel(shouldShow) {
  return {
    type: TOGGLE_CONVERSATION_INFO_PANEL,
    payload: {
      shouldShow,
    },
  };
}

function setUrlConversationLoading(isLoading, conversationId = null) {
  return {
    type: SET_URL_CONVERSATION_LOADING,
    payload: {
      isLoading,
      conversationId,
    },
  };
}

function setUrlConversationError(error) {
  return {
    type: SET_URL_CONVERSATION_ERROR,
    payload: error,
  };
}

function setMailMessages(conversationId, messages) {
  return {
    type: SET_MAIL_MESSAGES,
    payload: { conversationId, messages },
  };
}

function updateMailHistory(conversationId, messages) {
  return {
    type: UPDATE_MAIL_HISTORY,
    payload: { conversationId, messages },
  };
}

function setAllMailMessagesLoaded(conversationId) {
  return {
    type: ALL_MAIL_MESSAGES_LOADED,
    payload: { conversationId },
  };
}

function setAutomationStatus(conversationId, isPaused, respondsAs = null) {
  return {
    type: SET_AUTOMATION_STATUS,
    payload: { conversationId, isPaused, respondsAs },
  };
}

function setConversationFilter(filter) {
  return {
    type: SET_CONVERSATION_FILTER,
    payload: filter,
  };
}

const Actions = {
  setUserName,
  setUserOnline,
  setSystemTypingData,
  setConversations,
  appendConversations,
  setConversationPagination,
  setConversationId,
  setRoomMessages,
  updateRoomMessages,
  updateRoomHistory,
  setParticipantsDetails,
  setParticipantsCount,
  updateConversation,
  setSystemMessageSeenData,
  setAllMessagesAreLoaded,
  setMessageLoadingState,
  setConversationTopicList,
  updateConversationTopic,
  updateConversationTopics,
  selectConversationTopic,
  loadingConversationTopics,
  updateConversationLastActivity,
  updateConversationsList,
  addToSendMessageQueue,
  removeFromSendMessageQueue,
  updateUserPermissions,
  updateLastSeen,
  toggleConversationInfoPanel,
  removeConversation,
  setUrlConversationLoading,
  setUrlConversationError,
  setMailMessages,
  updateMailHistory,
  setAllMailMessagesLoaded,
  setAutomationStatus,
  setConversationFilter,
};

export default Actions;
